// 全屏-温湿度
<template>
  <div class="DkbFHumiture">
  </div>
</template>

<script>
  import { localUserInfo, showToast } from "../../../../static/js/utility/utility.js"
  let vm

  export default {
    name: 'DkbFHumiture',
    components: {
    },
    data () {
      return {
      }
    },
    created () {
      vm = this
   
    },
    mounted() {
      // console.log('route', this.$route)
    },
    computed: {
    },
    methods: {
    },
    watch: {
    }
  }
</script>

<style lang="scss" scoped>
.DkbFHumiture {

}
</style>



// WEBPACK FOOTER //
// src/components/DkbPage/FScreen/Humiture.vue